import icon1 from '../../images/foodIcons/icon1.png';
import icon2 from '../../images/foodIcons/icon2.png';
import icon3 from '../../images/foodIcons/icon3.png';
import icon4 from '../../images/foodIcons/icon4.png';
import icon5 from '../../images/foodIcons/icon5.png';
import icon6 from '../../images/foodIcons/icon6.png';
import icon7 from '../../images/foodIcons/icon7.png';
import icon8 from '../../images/foodIcons/icon8.png';
import icon9 from '../../images/foodIcons/icon9.png';
import icon10 from '../../images/foodIcons/icon10.png';

const sliderData = [
  { category: 'recommended', icon: icon4 },
  { category: 'american', icon: icon8 },
  { category: 'malay', icon: icon6 },
  { category: 'chinese', icon: icon2 },
  { category: 'japanese', icon: icon10 },
  { category: 'korean', icon: icon3 },
  { category: 'spanish', icon: icon1 },
  { category: 'italian', icon: icon5 },
  { category: 'thai', icon: icon9 },
  { category: 'indian', icon: icon7 },
];

export default sliderData;
